var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#002575",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.324 1.027c.167-.174.415-.243.648-.182.233.06.415.243.476.476.061.233-.008.481-.181.648L12.6 4.633c1.059.668 2.023 1.475 2.867 2.4.494.548.496 1.38.004 1.932-1.708 1.877-4.53 3.866-7.367 3.866h-.2c-.99-.017-1.966-.23-2.873-.626L2.267 14.97c-.225.224-.577.259-.84.083-.265-.176-.368-.514-.248-.808.006-.005.012-.007.018-.011l13-13c.053-.055.092-.122.115-.194zM8 3.167c.733-.004 1.462.108 2.16.332.057.018.099.064.112.121.014.058-.003.118-.045.16L8.933 5.073c-.042.042-.103.058-.16.041C8.523 5.042 8.262 5.003 8 5 6.343 5 5 6.343 5 8c.004.262.043.522.117.773.017.057.001.118-.04.16l-2.03 2.034c-.059.058-.15.066-.218.019-.834-.589-1.603-1.266-2.292-2.02C.04 8.417.041 7.579.542 7.033 2.267 5.133 5.133 3.128 8 3.167zm2.617 3.546c-.054-.009-.109.01-.147.048l-3.707 3.706c-.038.039-.056.094-.047.148.009.054.043.1.093.124.649.298 1.386.343 2.066.126.959-.303 1.706-1.057 2-2.018.208-.674.16-1.4-.134-2.041-.023-.05-.07-.084-.124-.093z",
    transform: "translate(-120 -49) translate(31 33) translate(81 8) translate(8 8)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.0bc92afba2b8d85333be88cc68f6314e.svg";
export { ForwardRef as ReactComponent };